import React, { Component } from 'react';

import GMSGeometry from '../Helpers/GMSGeometry';
class MapsShapeDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSmallExpanded: false,
            name:'',
            isEditedShapeName: false,
            isOpenModal:false,
        };
        this.activateSmallExpanded = this.activateSmallExpanded.bind(this);
        this.deactivateSmallExpanded = this.deactivateSmallExpanded.bind(this);
        this.handleClose = this.handleClose.bind(this)
        this.handleEditName = this.handleEditName.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
    }

    activateSmallExpanded() {
        this.setState({
            isSmallExpanded: true
        });
    }

    deactivateSmallExpanded() {
        this.setState({
            isSmallExpanded: false
        });
    }

    handleClose(){
        const {setSelectedShape} = this.props
        this.deactivateSmallExpanded()
        setSelectedShape(null)
    }

    handleEditName(){
        this.setState({
            isEditedShapeName:true
        })
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleSubmit(event){
        event.preventDefault()
        const { name } = this.state
        const { selectedShape } = this.props
        selectedShape.name = name
        this.setState({
            isEditedShapeName:false,
            name:''
        })
    }

    handleDelete(){
        const { deleteShape, setCurrentPlan, selectedShape, currentPlan, setSelectedShape } = this.props
        currentPlan.shapesArray = currentPlan.shapesArray.filter(function( obj ) {
            if(obj.coordsArray === selectedShape.coordsArray){
                deleteShape(obj)
            }
            return obj.coordsArray !== selectedShape.coordsArray;
        })
        setSelectedShape(null)
        setCurrentPlan(currentPlan)
    }

    render() {
        const { isSmallExpanded, isEditedShapeName, name } = this.state;
        const { isLoaded, selectedShape, user, isEdited, isDrawed } = this.props;

        var mapsDetailsClasses = 'MapsDetails box';
        var closeButton = <span onClick={this.handleClose} className="CloseMenu"><i className="fas fa-times"></i></span>
        var shapeName = ''
        var editedNameButton = null
        var divShapeName = null
        var dropdown = null

        if ( isSmallExpanded === true ) {
            mapsDetailsClasses += ' is-small-expanded';
            closeButton = null
        }

        if ( !isLoaded ) {
            return (
                <div className={mapsDetailsClasses}>
                    <span className="MapsDetailsLoadingIcon icon is-medium">
                        <i className="fas fa-spinner fa-pulse fa-2x"></i>
                    </span>
                </div>
            );
        }
        else if ( selectedShape === undefined || selectedShape === null || selectedShape === false ) {
            return (
                <div className={mapsDetailsClasses}>
                    <div className="content">
                        <div className="MapsPlanHeader">
                            <h5 className="MapsPlanName title has-text-white is-size-5">ไม่พบข้อมูล</h5>
                            <p className="MapsPlanErrorDescription has-text-grey-light">The link you followed may be broken, or the page may have been removed.</p>
                        </div>
                    </div>
                </div>
            );
        }

        const shapeUtmString = GMSGeometry.latLngToUtmString(selectedShape.shapeLatLng());

        var areaOutput = null

        if( selectedShape.type === 'polygon' ){
            areaOutput =    <div className="MapsPlanFieldValue">
                                <p className="MapsPlanField has-text-grey-light has-text-weight-bold">ขนาดพื้นที่</p>
                                <p className="MapsPlanValue">{selectedShape.shapeAreaString()}</p>
                            </div>
        }
        else if ( selectedShape.type === 'polyline' ){
            areaOutput =    <div className="MapsPlanFieldValue">
                                <p className="MapsPlanField has-text-grey-light has-text-weight-bold">ความยาว</p>
                                <p className="MapsPlanValue">{selectedShape.shapeDistance()}</p>
                            </div>
        }

        selectedShape.name !== '' ? shapeName = selectedShape.name : shapeName = selectedShape.type 

        
        if ( user !== null && user !== undefined && selectedShape !== undefined && selectedShape !== null && selectedShape !== [] && ( selectedShape.userUid === user.uid || selectedShape.userUid === '')){
            editedNameButton = <i onClick={this.handleEditName} className="fas fa-edit edit-shapename"></i>
            dropdown =  <i className="far fa-trash-alt is-trash-icon" onClick={this.handleDelete}></i>
        }

        if( isEdited || isDrawed ){
            if( isEditedShapeName ){
                divShapeName =  <form className="form-shapename" onSubmit={this.handleSubmit}>
                                    <input className="shapename-input input is-rounded" type="text" onChange={this.handleChange} name="name" value={name} placeholder={shapeName}></input>
                                    <button className="shapename-save is-primary button is-rounded" type="submit" >
                                        <i className="fas fa-save"></i>
                                    </button>
                                </form>
            }
            else {
                divShapeName =  <div className="shapename-and-button">
                                    <h5 className="MapsPlanName title has-text-white is-size-5">{shapeName}</h5>
                                    {editedNameButton}
                                    {dropdown}
                                </div>
            }
        }
        else if ( !isEdited && !isDrawed ){
            divShapeName =  <div className="shapename-and-button">
                                <h5 className="MapsPlanName title has-text-white is-size-5">{shapeName}</h5>
                            </div>
        }

        return (
            <div className={mapsDetailsClasses}>
                <div className="MapsDetailsExpander has-text-grey-lighter has-text-centered" onClick={this.activateSmallExpanded}>
                    <span className="icon"><i className="fas fa-chevron-up fa-lg"></i></span>
                </div>
                <div className="MapsDetailsCollapser has-text-grey-lighter" onClick={this.deactivateSmallExpanded}>
                    <span className="icon"><i className="fas fa-times fa-lg"></i></span>
                </div>
                <div className="content">
                    <div className="MapsPlanHeader">
                        {closeButton}
                        {divShapeName}
                        <p className="MapsPlanCreatedAt has-text-grey-light is-size-7">{selectedShape.createdAtString()}</p>
                    </div>
                    <div className="MapsPlanMoreDetails">
                        <hr />
                        <h6 className="title is-size-6">ข้อมูลทางภูมิศาสตร์</h6>
                        <div className="MapsPlanFieldValue">
                            <p className="MapsPlanField has-text-grey-light has-text-weight-bold">ตำแหน่ง X, Y</p>
                            <p className="MapsPlanValue">{shapeUtmString}</p>
                        </div>
                        {areaOutput}
                    </div>
                </div>
            </div>
        );
    }

}

export default MapsShapeDetails


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsShapeDetails.js